import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { IRolRespByUid, RolesOptionsType } from "src/app/models/Identity/role";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";
import { IDeleteRoleResponse } from "../../interfaces/auth.interface";
import { Router } from "@angular/router";
import { roleIdByName } from "../../constants/auth.constants";

@Injectable({
  providedIn: "root",
})
export class RolManagementService {
  usersDeleteRole = `${environment.apiUrlCap}/userRole/`;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  deleteRolUserId(roleUserId: number): Observable<IDeleteRoleResponse> {
    return this.http
      .delete<ResponseDataInterfaces<IDeleteRoleResponse>>(
        `${this.usersDeleteRole}` + roleUserId
      )
      .pipe(map(({ data }) => data));
  }

  getAvailableRoles(): Observable<IRolRespByUid[]> {
    const url = `${environment.apiUrlCap}/api/catalogs/roles`;
    return this.http
      .get<ResponseDataInterfaces<IRolRespByUid[]>>(url)
      .pipe(map(d => d.data));
  }

  getRoleNameById(
    roleId: roleIdByName,
    changeHeadDev?: boolean
  ): RolesOptionsType | "Desarrollo" {
    if (changeHeadDev && roleId === roleIdByName.jefeDesarrollo) {
      return "Desarrollo";
    }
    switch (roleId) {
      case roleIdByName.instructor:
        return "Instructor";
      case roleIdByName.jefeDesarrollo:
        return "Jefe Desarrollo";
      case roleIdByName.oficinasNacionales:
        return "Oficinas nacionales";
      case roleIdByName.liderNacional:
        return "Líder nacional";
    }
  }
}
